import "./SubscriptionPreferencesFormInputGroup.scss";

import React, { useMemo, useState } from "react";
import { SubscriptionPreferencesFormInputComponent } from "../formInput/SubscriptionPreferencesFormInputComponent";
import { ISubscriptionPreferencesFormInputGroupProps } from "./SubscriptionPreferencesFormInputGroupModel";

export function SubscriptionPreferencesFormInputGroupComponent({
    label,
    IconElement,
    inputHolderClassName,
}: ISubscriptionPreferencesFormInputGroupProps) {
    const [focused, setFocus] = useState(false);
    const [focus, blur] = useMemo(
        () => [() => setFocus(true), () => setFocus(false)],
        []
    );

    return (
        <>
            <label
                className="usmSubscriptionPreferencesFormInputGroup"
                onClick={focus}>
                {label}
            </label>

            <SubscriptionPreferencesFormInputComponent
                className={inputHolderClassName}
                focused={focused}
                focus={focus}
                blur={blur}
                IconElement={IconElement}
            />
        </>
    );
}
